import { ChecksReportAvailability } from 'src/app/pages/checks-report/models/checks-report-availability.model';
import { ChecksReportService } from 'src/app/pages/checks-report/checks-report.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { map, skip } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { SecurityService } from 'src/@dva/services/security.service';
import { ThemeService } from 'src/@dva/services/theme.service';

@Component({
  selector: 'dva-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit, OnDestroy {
  visible$ = this.themeService.config$.pipe(map((config) => config.footerVisible));
  type$ = this.themeService.config$.pipe(map((config) => config.footerType));
  companyId: number;
  dontShowAgain = false;
  reportIdentifier: string;

  constructor(
    private themeService: ThemeService,
    private securityService: SecurityService,
    private checksReportService: ChecksReportService,
    private router: Router,
    private dialogRef: MatDialog,
  ) {}

  ngOnInit() {
    const user = this.securityService.getUser();
    if (user) {
      this.companyId = user.companyId;
      const isDisplayInitialMessage = user.isDisplayInitialMessage;
      if (isDisplayInitialMessage) this.themeService.setFooterType('initial');
      this.themeService.setFooterVisible(isDisplayInitialMessage);
    }
    this.themeService.config$
      .pipe(skip(1))
      .pipe(map((config) => config.footerReportIdentifier))
      .subscribe((reportIdentifier) => {
        this.reportIdentifier = reportIdentifier;
      });
  }

  download() {
    this.checksReportService.isDownloadAvailable(this.reportIdentifier).subscribe((checksReport) => {
      if (checksReport.isDownloadAvailable) {
        this.checksReportService.download(this.reportIdentifier).subscribe((data) => {
          this.downloadByBlob(data, checksReport);
          this.hide();
        });
      } else {
        this.dialogRef.closeAll();
        this.router.navigate(['checks-report']);
        this.hide();
      }
    });
  }

  private downloadByBlob(data: Blob, checksReport: ChecksReportAvailability) {
    var downloadURL = window.URL.createObjectURL(data);
    var link = document.createElement('a');
    link.href = downloadURL;
    link.download = checksReport.fileName;
    link.click();
  }

  hide() {
    if (this.dontShowAgain) {
      this.securityService.disableInitialMessage(this.companyId);
    }
    this.themeService.setFooterVisible(false);
    this.themeService.setFooterType('initial');
    this.themeService.setFooterReportIdentifier('');
  }

  ngOnDestroy(): void {}
}
